<p-table [value]="commentCategories" dataKey="id" [tableStyle]="{ 'min-width': '50rem' }">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem"></th>
        <th>Category Name</th>
        <th>Color</th>
        <th>Actions</th>
      </tr>
    </ng-template>
  
    <ng-template pTemplate="body" let-category let-expanded="expanded">
      <tr>
        <td>
          <button
            type="button"
            [pRowToggler]="category"
            pButton
            class="p-button-text p-button-rounded p-button-plain"
            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
            *ngIf="category.childCategories?.length > 0">
          </button>
        </td>
        <td>{{ category.name }}</td>
        <td>
          <div [style.background]="category.color" style="width: 20px; height: 20px; border-radius: 50%;"></div>
        </td>
        <td>
          <span class="btnBars">
            <i class="pi pi-pencil" (click)="editCategory(category)" pTooltip="Edit Category"
                tooltipPosition="top"></i>
        </span>
        <span class="btnBars">
            <i class="pi pi-trash" (click)="deleteCategory(category.id)" pTooltip="Delete Category"
                tooltipPosition="top"></i>
        </span>
        </td>

      </tr>
    </ng-template>
  
    <ng-template pTemplate="rowexpansion" let-category>
      <tr *ngFor="let child of category.childCategories">
        <td></td>
        <td style="padding-left: 2rem !important;">{{ child.name }}</td>
        <td>
          <div [style.background]="child.color" style="width: 20px; height: 20px; border-radius: 50%;"></div>
        </td>
        <td>
            <span class="btnBars">
                <i class="pi pi-pencil" (click)="editChildCategory(category, child)" pTooltip="Edit Subcategory"
                    tooltipPosition="top"></i>
            </span>
            <span class="btnBars">
                <i class="pi pi-trash" (click)="deleteChildCategory(category.id, child.id)" pTooltip="Delete Subcategory"
                    tooltipPosition="top"></i>
            </span>
        </td>
      </tr>
    </ng-template>
  
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4">No categories available</td>
      </tr>
    </ng-template>
  </p-table>

  <app-add-update-comment-category *ngIf="displayCreateUpdateCommentCategory"
  [displayCreateUpdateCommentCategory]="displayCreateUpdateCommentCategory"
  [isEditMode]="isEditMode"
  [initialData]="selectedCategory"
  [commentCategories]="commentCategories"
  (hideCreateUpdateCategory)="hideCreateUpdateCategory($event)"
  (refreshCategory)="refreshCategory($event)"
  [showParentCategory]="showParentCategory"  
  >
</app-add-update-comment-category>

  